import { jsx } from 'react/jsx-runtime';
import cn from 'classnames';
import SvgSpinner from './spinner.svg.js';
import S from './Spinner.styl.js';

const Spinner = ({ size = 'm', className = '', ...props }) => {
    const classes = cn(S.root, S[`size-${size}`], className);
    return jsx(SvgSpinner, { className: classes, ...props });
};

export { Spinner };
